import Collapse from "@mui/material/Collapse";
import React from "react";
import styled from "styled-components";
import Context from "../contexts/data";

const ErrorMessage = () => {
  const { errorMessage } = React.useContext(Context);
  return (
    <Collapse in={!!errorMessage}>
      <TextContainer>
        <Text>{errorMessage}</Text>
      </TextContainer>
    </Collapse>
  );
};

const TextContainer = styled.div``;

const Text = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #d0342c;
  margin: 0px 0px 16px 0px;
`;

export default ErrorMessage;
